import { makeContextModule } from '@cian/react-utils';

export interface IMapContext {
  ymaps: YMaps.IYMaps;
  map: YMaps.Map;
  center: YMaps.TCoord;
}

export const { Context: MapContext, useContext: useMapContext } = makeContextModule<IMapContext>({
  contextName: 'MapContext',
});
